// src/locales/si/couriers.js
export const couriers = {
  // Business Couriers
  pageTitle: "ව්‍යාපාරික කුරියර්",
  pageDescription: "කුරියර් සමාගම් පැවරීම් හා සැකසුම් කළමනාකරණය කරන්න",
  assignCourier: "කුරියර් ලබාදෙන්න",
  noCouriersAssigned: "කුරියර් සැපයූවාක් නොමැත",
  noCouriersFound: "කුරියර් සොයාගත නොහැක",
  startByAssigning: "ඔබේ ව්‍යාපාරයට කුරියර් සමාගමක් ලබාදීමෙන් ආරම්භ කරන්න",
  searchCouriers: "කුරියර් ಹುಡುන්න...",
  assignFirstCourier: "පළමු කුරියරය ලබාදෙන්න",
  clearSearch: "සෙවීම මකන්න",
  loadingCouriers: "කුරියර් Load වෙමින්...",
  loadingMessage: "ඔබගේ කුරියර් පවරීම් Load වන තුරු රැඳී සිටින්න",
  unableToLoad: "කුරියර් Load කළ cannot",
  retry: "නැවත උත්සාහ කරන්න",
  noMatchingCouriers: "සෙවීම සඳහා ගැලපෙන කුරියර් නැත",
  courier: "කුරියර්",
  status: "තත්වය",

  // Stats
  totalAssigned: "පවරා ඇති ගණන",
  active: "Active",
  apiEnabled: "API සක්‍රීයයි",

  // Badges
  activeStatus: "Active",
  inactiveStatus: "Inactive",
  apiEnabledBadge: "API සක්‍රීය",
  webhookEnabledBadge: "Webhook සක්‍රීය",

  // Actions
  configure: "Configure කරන්න",
  remove: "Remove කරන්න",
  save: "සැකසුම් Save කරන්න",
  cancel: "අවලංගු",
  close: "වහන්න",
  saving: "Save කරමින්...",

  // Assign Modal
  assignModalTitle: "කුරියර් සමාගමක් ලබාදෙන්න",
  assignModalDescription: "ඔබගේ ව්‍යාපාරයට පවරන්න කුරියර් සමාගම් තෝරන්න.",
  noCouriersAvailable: "කුරියර් සමාගම් නොමැත",
  assign: "Assign",
  assigning: "Assign කරමින්...",

  // Configuration Modal
  configureModalTitle: "Configure",
  generalSettings: "සාමාන්‍ය සැකසුම්",
  activeStatusLabel: "Active තත්ත්වය",
  activeStatusHint: "මෙම කුරියර් පවරීම සක්‍රීය/අක්‍රීය කරන්න",

  // API Configuration
  apiConfiguration: "API සැකසුම්",
  enableApiIntegration: "API Integration සක්‍රීය කරන්න",
  enableApiHint: "Waybill නිර්මාණය ස්වයංක්‍රීය කිරීමට API සක්‍රීය කරන්න",
  apiKey: "API Key",
  apiKeyPlaceholder: "API Key ඇතුලත් කරන්න",
  apiKeyHint: "API Key කුරියර් සමාගමෙන් ලබාගන්න",
  enableApiUpload: "Orders API හරහා Upload කරන්න",
  enableApiUploadHint: "අක්‍රීය කළහොත්, orders කුරියර් වෙත ස්වයංක්‍රීයව upload නොවේ; ඒ වෙනුවට waybill range එකෙන් airwaybill number manual ලෙස generate වේ. API Integration සක්‍රීයව ඇති තාක් tracking (getPackageDetails) ක්‍රියාත්මක වේ.",
  apiEndpoint: "API Endpoint",
  apiEndpointPlaceholder: "https://api.courier.com/v1",
  apiEndpointHint: "අමතර API endpoint URL (හෝ Optional)",
  additionalApiConfig: "අමතර API Config",
  additionalApiConfigPlaceholder: '{"merchantId": "12345", "senderName": "Your Business"}',
  additionalApiConfigHint: "JSON format Configurable parameters",

  // Waybill Configuration
  waybillConfiguration: "Waybill Range සැකසුම්",
  waybillDescription: "Manual waybill number range configure කරන්න",
  waybillRangeStart: "Range ආරම්භය",
  waybillRangeStartPlaceholder: "උදා: AWB000001",
  waybillRangeEnd: "Range අවසානය",
  waybillRangeEndPlaceholder: "උදා: AWB999999",
  lastWaybillUsed: "අවසන් භාවිතා Waybill",
  waybillRange: "Waybill Range",
  lastUsed: "අවසන් භාවිතය",

  // Webhook Configuration
  webhookConfiguration: "Webhook සැකසුම්",
  enableWebhook: "Webhook සක්‍රීය කරන්න",
  enableWebhookHint: "කුරියර් status updates realtime ලබා ගැනීම",
  webhookUrl: "Webhook URL",
  webhookUrlHint: "මෙම URL කුරියර් සමාගම් වෙත ලබාදෙන්න",
  regenerateWebhook: "Webhook URL නැවත ජනිත කරන්න",
  regenerating: "Regenerating...",

  // Delete Modal
  confirmRemoval: "ඉවත් කිරීම තහවුරු කරන්න",
  removeConfirmation: "ඔබට ඉවත් කිරීමට අවශ්‍ය බව තහවුරු කරන්න",
  removeWarning: "මෙය කුරියර් පවරීම සහ සැකසුම් සියල්ලයි ඉවත් කරයි.",
  removeCourier: "කුරියර් ඉවත් කරන්න",
  removing: "ඉවත් කරමින්...",
  cannotRemove: "ඉවත් cannot",
  hasRelatedRecords: "ඒවාට සම්බන්ධ data තිබෙන නිසා:",
  removeRelatedRecordsFirst: "එම data මකා/නැවත පවරා ඉවත් කරන්න.",
  packingBatches: "packing batch",
  orders: "order",
  assignmentRulesCount: "rule",

  // Account Name
  accountName: "ගිණුම් නම",
  accountNamePlaceholder: "උදා: ප්‍රධාන ගිණුම",
  accountNameHint: "මෙම කුරියර් ගිණුමේ නම",
  accountNameRequired: "ගිණුම් නම අවශ්‍යයි",

  // Column Mapping Overrides
  mappings: {
    modalTitle: "Column Mappings",
    modalDescription: "මෙම කුරියර් ගිණුම සඳහා custom overrides. ගෙවල් defaults ට වඩා ප්‍රමුඛතාව ගනී.",
    openMappings: "Column Mappings",
    loadError: "Mapping overrides පූරණය කිරීමේ දෝෂයකි",
    invoiceType: "Courier Invoice Mapping",
    uploadType: "Upload Format Mapping",
    noOverride: "ගෙවල් default mapping භාවිතා කරයි",
    createOverride: "Override සෑදෙන්න",
    edit: "සංස්කරණය",
    delete: "මකන්න",
    save: "Mapping සාදන්න",
    mappingName: "Mapping නම",
    mappingNamePlaceholder: "උදා: Custom Invoice Format",
    mappingConfig: "Mapping Configuration (JSON)",
    mappingConfigHint: "JSON mappingConfig object",
    notes: "සටහන්",
    notesPlaceholder: "Optional developer notes...",
    activeStatus: "සක්‍රිය",
    nameRequired: "Mapping නම අවශ්‍යයි",
    invalidJson: "JSON format වැරදියි",
    configMustBeObject: "Mapping config JSON object විය යුතුයි",
    createSuccess: "Mapping override සාදා ගත්තා",
    updateSuccess: "Mapping override යාවත්කාලීන කළා",
    deleteSuccess: "Mapping override මකා දැමුවා",
    saveError: "Mapping override සැකසීමේ දෝෂයකි",
    deleteError: "Mapping override මකා දැමීමේ දෝෂයකි",
    deleteConfirm: "මෙම mapping override මකන්නද? කුරියර් ගෙවල් default ට ආපසු යයි."
  },

  // Validation Errors
  invalidUrl: "වලංගු URL ඇතුලත් කරන්න",
  invalidJson: "වලංගු JSON format නොවේ",
  rangeError: "අවසන් Range අරඹු Range ට වඩා අඩු cannot",
  apiKeyRequired: "API Enable කර ඇති විට API Key අවශ්‍යයි",

  // Success Messages
  assignSuccess: "කුරියර්(s) සාර්ථකව පවරා ඇත",
  createSuccess: "{count} කුරියර් ගිණුම් සෑදූවා",
  updateSuccess: "කුරියර් සැකසුම් update විය",
  removeSuccess: "කුරියර් ඉවත් විය",
  webhookEnabledSuccess: "Webhook සක්‍රීය විය",
  webhookDisabledSuccess: "Webhook අක්‍රීය විය",
  webhookRegeneratedSuccess: "Webhook Secret නැවත ජනිත විය",

  // Error Messages
  assignError: "කුරියර් පවරාගැනීම අසාර්ථකයි",
  updateError: "කුරියර් Update අසාර්ථකයි",
  removeError: "කුරියර් ඉවත් cannot",
  loadError: "ව්‍යාපාරික කුරියර් load cannot",
  loadAvailableError: "ලබාගත හැකි කුරියර් load cannot",
  noChanges: "Save කිරීමට වෙනස්කම් නැත",
  selectAtLeastOne: "අවම වශයෙන් කුරියර් සමාගමක් තෝරන්න",
  webhookEnableError: "Webhook enable cannot",
  webhookDisableError: "Webhook disable cannot",
  webhookRegenerateError: "Webhook regenerate cannot",

  // Card Details
  addedOn: "එක් කළ දිනය",
  customEndpoint: "Custom Endpoint",

  // Contact Info
  phone: "දුරකථන",
  email: "Email",
  website: "Website",
  address: "ලිපිනය",

  // Assignment Rules
  assignmentRules: "කුරියර් පවරීම් නියමයන්",
  assignmentRulesDescription: "Shop / Geography අනුව නියමයන් දමන්න",
  createRule: "Rule එකක් සෑදෙන්න",
  createFirstRule: "පළමු Rule සාදන්න",
  editRule: "Rule සංස්කරණය",
  createRuleTitle: "Rule එකක් Create කරන්න",
  noRulesYet: "Rules නොමැත",
  noRulesDescription: "සැලසුම් automate කිරීමට Rules සෑදෙන්න",
  searchRules: "Rules සොයන්න...",
  noRulesFound: "Rules සොයාගත cannot",
  noMatchingRules: "Filters වලට ගැලපෙන Rules නැත",
  loadingRules: "Rules load වෙමින්...",
  loadingRulesMessage: "Rules load වන තුරු රැඳී සිටින්න",
  unableToLoadRules: "Rules load cannot",

  // Rule Stats
  totalRules: "Rules",
  couriersConfigured: "Configured Couriers",
  defaultRules: "Default Rules",
  defaultFirst: "Default First",
  hasDefault: "Default Rule ඇත",

  // Rule Form
  basicInformation: "මූලික තොරතුරු",
  courierCompany: "කුරියර් සමාගම",
  selectCourierCompany: "කුරියර් සමාගම තෝරන්න",
  ruleName: "Rule නම",
  ruleNamePlaceholder: "උදා: කොළඹ ප්‍රධාන ප්‍රදේශ",
  priority: "ප්‍රමුඛතාව",
  priorityHint: "සාපේක්ෂ ප්‍රමුඛතාව (ඉහළ → First)",
  description: "විස්තරය",
  descriptionPlaceholder: "Optional විස්තර...",
  ruleConfiguration: "Rule Config",
  ruleConfigDescription: "Rules apply වන්නේ Shop → City → Zone → District → Province",
  setAsDefault: "Default Rule කරන්න",
  setAsDefaultHint: "එක් Courier සඳහා Rule එකක් Default විය හැක",
  unsetAsDefault: "Default ඉවත් කරන්න",

  // Rule Types
  shopRules: "Shop Rules",
  cityRules: "City Rules",
  shippingZoneRules: "Zone Rules",
  districtRules: "District Rules",
  provinceRules: "Province Rules",

  // Rule Actions
  addRule: "Rule එකක් එක් කරන්න",
  noRulesConfigured: "Rules configure කර නොමැත",
  include: "Include",
  exclude: "Exclude",
  showDetails: "විස්තර පෙන්වන්න",
  hideDetails: "සඟවන්න",
  duplicate: "Duplicate",
  copy: "Copy",

  // Rule Selection
  selectMultipleHint: "Multiple තෝරාගැනීමට Ctrl/Cmd තබා තෝරන්න",
  selected: "තෝරා ඇත",
  shop: "Shop",
  city: "City",
  zone: "Zone",
  district: "District",
  province: "Province",

  // Filters
  allCouriers: "සියලු කුරියර්",
  allStatus: "සියලු තත්ව",
  sortBy: "Sort කිරීම",
  sortByCourier: "Courier",
  sortByPriority: "Priority",
  sortByStatus: "Status",
  sortByDate: "Date Created",
  clearFilters: "Filters reset",

  // Delete Rule
  confirmDeletion: "Delete තහවුරු කරන්න",
  deleteRuleConfirmation: "Rule Delete කරන්නද?",
  deleteRuleWarning: "මෙය යථා තත්වයට නැවත ලබා ගත cannot.",
  deleteRule: "Rule Delete",
  deleting: "Deleting...",

  // Rule Success Messages
  ruleCreatedSuccess: "Rule සාර්ථකව සෑදුවා",
  ruleUpdatedSuccess: "Rule update විය",
  ruleDeletedSuccess: "Rule delete විය",
  ruleActivatedSuccess: "Rule activate විය",
  ruleDeactivatedSuccess: "Rule deactivate විය",
  defaultSetSuccess: "Default rule සකස් විය",
  defaultUnsetSuccess: "Default rule ඉවත් විය",

  // Rule Error Messages
  ruleCreateError: "Rule සෑදීමට නොහැකි විය",
  ruleUpdateError: "Rule update cannot",
  ruleDeleteError: "Rule delete cannot",
  ruleLoadError: "Rules load cannot",
  ruleToggleError: "Rule status toggle cannot",
  defaultToggleError: "Default status toggle cannot",

  // Rule Details
  configuration: "සැකසුම්",
  createdBy: "සෑදූ අය",
  updatedBy: "Update කළ අය",
  rules: "rules",
  rule: "rule",
  updateRule: "Rule update කරන්න",
  selectItemsToInclude: "Include කළ යුතු දෑ තෝරන්න",
  selectItemsToExclude: "Exclude කළ යුතු දෑ තෝරන්න",
  unknown: "Unknown",
  // Courier delivery charges (rate card)
  deliveryCharges: "Delivery Charges",
  deliveryChargesModalTitle: "Delivery Charges -",
  deliveryChargesModalDesc: "Set what this courier charges you for each shipping zone. Used to check courier invoices.",
  extraChargesDesc: "Courier charge per extra kilogram beyond the base delivery",
  deliveryChargesLoading: "Loading delivery charges...",
  saveDeliveryCharges: "Save Delivery Charges",
  deliveryChargesSaved: "Courier delivery charges saved successfully",
  deliveryChargesSaveFailed: "Failed to save courier delivery charges",
  deliveryChargesLoadFailed: "Failed to load courier delivery charges",
  deliveryChargesTab: "Delivery Charges",
  returnChargesTab: "Return Charges",
  returnChargesModalDesc: "Set what this courier charges you for returned orders in each shipping zone.",
  returnExtraChargesDesc: "Courier return charge per extra kilogram",
  setFreeReturnAll: "Free Returns for All",
  saveCharges: "Save Charges",
  bulkEditReturnCharges: "Bulk Edit Return Charges",
  returnChargeAmount: "Return Charge Amount",
  bulkEditReturnHint: "This amount will be applied to all shipping zones for returns",
  extraChargePerKgLabel: "Extra Charge per Kg",
  bulkEditExtraHint: "Leave empty to keep each zone's current extra charge"
};
